import { View } from "../../Core";
import { ModalHelper } from "../../Helpers/ModalHelper";
import Vue from "vue";
import { Uri } from "../../Core/Helpers/Uri";
import * as ajax from "@brightspark/sparkling-ajax-js";
import { IServiceResult } from "../../Models/IServiceResult";
import ValidationMessage from "../../Components/ValidationMessage/ValidationMessage.vue";

enum Action {
    AddItemToCart,
    GetItemDetail,
    Checkout,
}

interface IItem {
    id: string;
    size: string;
}

class ViewDataModel {

}

export class IndexView extends View<IndexView> {
    private _viewData: ViewDataModel = window.__VIEW_DATA;

    public constructor() {
        super();
        this.SetupVue();
    }

    SetupVue() {
        var modalHelper;
        const v = new Vue({
            el: ".app",
            data: {
                item: {} as IItem,
                showModal: false,
                itemValidationResults: {}
            },
            beforeMount() {
                modalHelper = new ModalHelper(this);
            },
            mounted() {
                
            },
            components: {
                ValidationMessage
            },
            methods: {
                
                beginAddItemToCart(itemId: string) {

                    ajax(Uri.getUri(Action[Action.GetItemDetail]) + "?itemId=" + itemId,
                            {
                                contentType: "application/json",
                                dataType: "json",
                                method: "get",
                            })
                        .done((res: any) => {

                            if (res.availableSizes.length === 1) {
                                this.addItemToCart({
                                    itemId: itemId,
                                    amount: 1,
                                    size: res.availableSizes[0].value
                                });
                            } else {
                                Object.assign(v.item, res);
                                v.itemValidationResults = {};
                                v.showModal = true;
                            }
                        });
                },

                addItemToCart(data: any) {

                    if (!data) {
                        data = {
                            itemId: v.item.id,
                            amount: 1,
                            size: v.item.size
                        }
                    }

                    ajax(Uri.getUri(Action[Action.AddItemToCart]),
                        {
                            contentType: "application/json",
                            dataType: "json",
                            method: "post",
                            data: data
                        })
                        .done((res: IServiceResult<any>) => {
                            if (!res.isSuccess) {
                                if (v.showModal) {
                                    v.itemValidationResults = res.validationResults;    
                                } else {
                                    modalHelper.getNotificationModal(res.validationSummary);
                                }
                                return;
                            }

                            v.showModal = false;

                            modalHelper.getModal({
                                title: "Toode on lisatud ostukorvi",
                                //text: text,
                                buttons: [
                                    {
                                        title: "Vormistan tellimuse",
                                        handler: () => {
                                            document.location.href = Uri.getUri(Action[Action.Checkout]);
                                        }
                                    },
                                    {
                                        title: "Jätkan ostlemist",
                                        default: true,
                                        handler: () => {
                                            modalHelper.hide();
                                        }
                                    }
                                ]
                            });
                        });
                },
            }
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Shop/IndexView.ts